import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { getImage } from '../data/images';
import { Reveal } from './Reveal';
const EDITORIAL_LABELS = [{
  en: 'Bright Interiors',
  es: 'Interiores Luminosos'
}, {
  en: 'Fully Furnished',
  es: 'Completamente Amoblada'
}, {
  en: 'Beautiful Water View',
  es: 'Hermosa Vista al Agua'
}];
export function InteriorSection() {
  const {
    lang,
    t
  } = useLanguage();
  const openLiving = getImage('openKitchenLiving');
  const dining = getImage('diningArea');
  const livingWater = getImage('livingWaterView');
  const bathroom = getImage('bathroom');
  return <section className="w-full bg-white py-20 lg:py-28" data-id="element-300" data-mp="3rqh47nu8rma0">
      <div className="mx-auto max-w-editorial px-5 lg:px-8" data-id="element-301" data-mp="3rppgez6vysua">
        <div className="grid gap-10 lg:grid-cols-12 lg:gap-14" data-id="element-302" data-mp="3vrkiw70jzc9n">
          <Reveal className="lg:col-span-7" data-id="element-303" data-mp="ncshq8u9t9g4">
            {openLiving && <figure className="h-[300px] w-full overflow-hidden sm:h-[420px] lg:h-[560px]" data-id="element-304" data-mp="s40p6zc1ikqn">
                <img src={openLiving.src} alt={lang === 'en' ? openLiving.altEn : openLiving.altEs} width={openLiving.width} height={openLiving.height} loading="lazy" decoding="async" className="h-full w-full object-cover" style={{
              objectPosition: openLiving.objectPosition
            }} data-id="element-305" data-mp="2x5r7govv3zt5" />
              </figure>}
          </Reveal>

          <div className="lg:col-span-5 lg:pt-10" data-id="element-306" data-mp="3fy3jy4g8chh0">
            <Reveal data-id="element-307" data-mp="3btm3of92wmaz">
              <h2 className="max-w-[16ch] font-display text-[32px] font-semibold uppercase leading-[1.03] text-midnight sm:text-[42px] lg:text-[48px]" data-id="element-308" data-mp="3budxpln12bz5">
                {t('Open-Concept Living', 'Espacios Abiertos para Disfrutar')}
              </h2>
              <div className="gold-rule mt-6 w-24" data-id="element-309" data-mp="1vfvtcqrd91sw" />
              <p className="mt-6 text-[15px] leading-relaxed text-ink/80 lg:text-base" data-id="element-310" data-mp="1vgnqw74ix9lt">
                {t('The kitchen, dining room and living area flow naturally together, creating a comfortable central space for everyday living and entertaining. Large windows fill the home with natural light and provide relaxing views of the water.', 'La cocina, el comedor y la sala se integran naturalmente para crear un espacio cómodo para la vida diaria y para compartir. Los amplios ventanales llenan la propiedad de luz natural y ofrecen relajantes vistas al agua.')}
              </p>
              <ul className="mt-8 space-y-3" data-id="element-311" data-mp="ibvayjvssfaj">
                {EDITORIAL_LABELS.map(label => <li key={label.en} className="flex items-center gap-4" data-id="element-312" data-mp="n33mpmklocqv">
                    <span aria-hidden="true" className="h-px w-8 bg-gold" data-id="element-313" data-mp="n57mptfdorlv" />
                    <span className="label-caps text-midnight" data-id="element-314" data-mp="r3xb0h1yftka">
                      {lang === 'en' ? label.en : label.es}
                    </span>
                  </li>)}
              </ul>
            </Reveal>

            <Reveal delay={0.06} data-id="element-315" data-mp="110a4bdtl85ei">
              {dining && <figure className="mt-10 h-[220px] w-full overflow-hidden sm:h-[280px]" data-id="element-316" data-mp="1b84jt7ocjhm2">
                  <img src={dining.src} alt={lang === 'en' ? dining.altEn : dining.altEs} width={dining.width} height={dining.height} loading="lazy" decoding="async" className="h-full w-full object-cover" style={{
                objectPosition: dining.objectPosition
              }} data-id="element-317" data-mp="166oz5gq2zd47" />
                </figure>}
            </Reveal>
          </div>
        </div>

        <div className="mt-16 grid gap-6 lg:grid-cols-12 lg:gap-10" data-id="element-318" data-mp="1k5erkj1ygom8">
          <Reveal className="lg:col-span-8" data-id="element-319" data-mp="1g4l41qsfdbtv">
            {livingWater && <figure data-id="element-320" data-mp="2co27zl60bfgz">
                <div className="h-[280px] w-full overflow-hidden sm:h-[400px] lg:h-[500px]" data-id="element-321" data-mp="2coc3tpdqggul">
                  <img src={livingWater.src} alt={lang === 'en' ? livingWater.altEn : livingWater.altEs} width={livingWater.width} height={livingWater.height} loading="lazy" decoding="async" className="h-full w-full object-cover" style={{
                objectPosition: livingWater.objectPosition
              }} data-id="element-322" data-mp="27vr8gjf6hvoy" />
                </div>
                <figcaption className="label-caps mt-4 text-ink/60" data-id="element-323" data-mp="2b50or6ir4cky">
                  {t('Living Room • Water View', 'Sala • Vista al Agua')}
                </figcaption>
              </figure>}
          </Reveal>

          <Reveal className="lg:col-span-4" delay={0.06} data-id="element-324" data-mp="22cgwcnt1z48k">
            {bathroom && <figure data-id="element-325" data-mp="26d97jmlhjj7h">
                <div className="h-[280px] w-full overflow-hidden sm:h-[360px] lg:h-[500px]" data-id="element-326" data-mp="26cr4a60eo4q2">
                  <img src={bathroom.src} alt={lang === 'en' ? bathroom.altEn : bathroom.altEs} width={bathroom.width} height={bathroom.height} loading="lazy" decoding="async" className="h-full w-full object-cover" style={{
                objectPosition: bathroom.objectPosition
              }} data-id="element-327" data-mp="2u2v4s4iarocu" />
                </div>
                <figcaption className="label-caps mt-4 text-ink/60" data-id="element-328" data-mp="s7nle73nqpqu">
                  {t('Bathroom', 'Baño')}
                </figcaption>
              </figure>}
          </Reveal>
        </div>
      </div>
    </section>;
}